module.exports = __webpack_public_path__ + "static/media/Rubik-Medium.6ee36f36.woff";